<template>
  <div>
    <FormKit type="form" @submit="passwordHandler" v-model="passwords">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Nueva contraseña -->
        <FormKit
          :type="claveVisible[1] ? 'text' : 'password'"
          prefix-icon="password"
          suffix-icon="eyeClosed"
          @suffix-icon-click="toggleVisibility(1)"
          suffix-icon-class="hover:text-blue-500"
          name="clave1"
          placeholder="••••••••"
          label="Nueva contraseña"
          help="Ingresá tu nueva contraseña"
        />
        <!-- Confirmar contraseña -->
        <FormKit
          :type="claveVisible[2] ? 'text' : 'password'"
          prefix-icon="password"
          suffix-icon="eyeClosed"
          @suffix-icon-click="toggleVisibility(2)"
          suffix-icon-class="hover:text-blue-500"
          name="clave2"
          placeholder="••••••••"
          validation="equals:clave1"
          label="Confirmar contraseña"
          help="Repetí tu nueva contraseña"
        />
      </div>
      <!-- Template para el submit -->
      <template #submit>
        <div class="flex justify-end">
          <FormKit
            type="submit"
            :classes="{ outer: 'flex justify-end w-full' }"
            label="Guardar"
          />
        </div>
      </template>
    </FormKit>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { notify } from "notiwind";
import { actualizarClave } from "@/services/usuarios";
// Clave visible para alternar visibilidad de las contraseñas
const claveVisible = ref([false, false, false]);

// Modelos para los datos de las contraseñas
const passwords = ref({
  claveActual: "",
  clave1: "",
  clave2: "",
});

// Método para alternar la visibilidad de las contraseñas
const toggleVisibility = (index) => {
  claveVisible.value[index] = !claveVisible.value[index];
};

// Manejador del envío del formulario
const passwordHandler = async (data) => {
  console.log("Datos enviados:", data);
  // Llamar al servicio para actualizar la contraseña
  await actualizarClave(data);
  // Limpiar los campos

  // Notificar al usuario
  notify(
    {
      group: "foo",
      // Success notification
      type: "success",
      title: "Contraseña actualizada",
      text: "Tu contraseña ha sido actualizada correctamente",
    },
    2000
  );
};
</script>

<style scoped>
/* Puedes añadir estilos específicos aquí */
</style>
